module.exports = __webpack_public_path__ + "static/media/file.bba4f5a4.png";